<template>
    <div>
        <section>
            <!-- <v-parallax src="../assets/scott-warman-h4AGlo55tTA-unsplash1.png" height="800"> -->
            <!-- <v-parallax src="../assets/kym-ellis-aF1NPSnDQLw-unsplash1.png" height="900"> -->
            <v-parallax src="../assets/kym-ellis-aF1NPSnDQLw-unsplash1.png" height="1300">
                <!-- <v-container fluid fill-height class="home"> -->

                <v-layout row align-center justify-center>
                    <v-flex xs12 class="text-center">
                        <div class="banner-tranqui">
                            <img :height="bannerIconHeight" src="../assets/tutranqui.png" />
                            <span
                                :class="bannerClass"
                            >&nbsp; Tú tranqui... Aquí está el Whats para pedir a domicilio: 55-5101-0200</span>
                            &nbsp;
                            <!-- <v-btn class="text-none" icon @click="onWhatsApp" v-on="on">
                                <img height="25" src="../assets/whatsapp.png" />
                            </v-btn>-->
                            <img
                                class="pointer"
                                :height="bannerIconHeight"
                                src="../assets/whatsapp.png"
                                @click="onWhatsApp"
                            />
                        </div>
                    </v-flex>
                </v-layout>

                <v-layout column align-center justify-center>
                    <v-flex xs10 sm4 class="text-center">
                        <img src="@/assets/catabocata1.png" :height="mainLogoHeight" />
                    </v-flex>
                </v-layout>

                <v-layout row align-center>
                    <v-flex xs12 class="text-center" color="white">
                        <v-btn
                            color="red darken-4"
                            class="text-none white--text"
                            rounded
                            elevation="12"
                            @click="onPromociones"
                        >Promociones</v-btn>
                    </v-flex>
                </v-layout>
                <v-layout row align-center justify-center>
                    <v-flex xs12 class="text-center">
                        <div class="home-buttons">
                            <v-btn
                                color="white"
                                class="text-none"
                                text
                                @click="onSucursales"
                            >Sucursales</v-btn>
                            <v-btn
                                large
                                color="white"
                                class="text-none"
                                text
                                @click="onCentrosConsumo"
                            >Atención a Centros de Consumo</v-btn>
                            <v-btn
                                large
                                color="white"
                                class="text-none"
                                text
                                @click="onPrivacidad"
                            >Políticas de Privacidad</v-btn>
                            <v-btn
                                large
                                color="white"
                                class="text-none"
                                text
                                @click="onContacto"
                            >Contacto</v-btn>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        large
                                        class="text-none"
                                        icon
                                        @click="onFacebook"
                                        v-on="on"
                                    >
                                        <img height="40" src="../assets/f_logo_RGB-Blue_58.png" />
                                    </v-btn>
                                </template>
                                <span>Síguenos en Facebook</span>
                            </v-tooltip>&nbsp;
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        large
                                        class="text-none"
                                        icon
                                        @click="onInstagram"
                                        v-on="on"
                                    >
                                        <img height="40" src="../assets/IG_Glyph_Fill.png" />
                                    </v-btn>
                                </template>
                                <span>Síguenos en Instagram</span>
                            </v-tooltip>&nbsp;
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        large
                                        class="text-none"
                                        icon
                                        @click="onWhatsApp"
                                        v-on="on"
                                    >
                                        <img height="40" src="../assets/whatsapp.png" />
                                    </v-btn>
                                </template>
                                <span>Servicio a Domicilio</span>
                            </v-tooltip>
                        </div>
                    </v-flex>
                </v-layout>
                <!-- <v-layout column align-center justify-center>
                    <v-flex xs10 sm4 class="text-xs-center text-center pointer">
                        <img
                            src="@/assets/tutranqui.jpg"
                            :height="mainLogoHeight"
                            @click="onWhatsApp"
                        />
                    </v-flex>
                </v-layout>-->
                <v-layout row align-center justify-center>
                    <v-flex xs12 class="text-xs-center text-center">
                        <div class="text-center">
                            <h2 class="headline brown--text text--darken-4">Encuéntranos en:</h2>
                        </div>
                    </v-flex>
                </v-layout>
                <v-layout row align-center justify-center>
                    <v-flex xs12 class="text-xs-center text-center">
                        <v-btn
                            height="150"
                            width="150"
                            class="text-none"
                            icon
                            text
                            @click="onUberEats"
                        >
                            <img height="120" src="../assets/uber-eats.png" />
                        </v-btn>
                        <v-btn
                            height="150"
                            width="150"
                            class="text-none"
                            icon
                            text
                            @click="onSinDelantal"
                        >
                            <img height="120" src="../assets/sin-delantal.png" />
                        </v-btn>

                        <v-btn
                            height="150"
                            width="150"
                            class="text-none"
                            icon
                            text
                            @click="onCornerShop"
                        >
                            <img height="120" src="../assets/cornershop.png" />
                        </v-btn>

                        <v-btn
                            height="150"
                            width="150"
                            class="text-none"
                            icon
                            text
                            @click="onDiDiFood"
                        >
                            <img height="120" src="../assets/didi-food.png" />
                        </v-btn>
                    </v-flex>
                </v-layout>
                <!-- </v-container> -->
            </v-parallax>
        </section>
        <!-- <v-footer absolute color="black" dark>
            <v-spacer></v-spacer>
            <div>
                Página desarrollada por:
                &nbsp;
                <v-btn height="30" width="50" class="text-none" icon text @click="onGTSF">GTSF</v-btn>
                &nbsp; v. {{ version }}
            </div>
        </v-footer>-->
        <v-footer absolute color="black" dark>
            <v-spacer></v-spacer>
            v. {{ version }}
        </v-footer>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex';

export default {
    name: 'home',
    data() {
        return {};
    },
    created() {
        // var bp = '';
        // if (this.$vuetify.breakpoint.xs) {
        //     bp = 'xs';
        // } else if (this.$vuetify.breakpoint.sm) {
        //     bp = 'sm';
        // } else if (this.$vuetify.breakpoint.md) {
        //     bp = 'md';
        // } else if (this.$vuetify.breakpoint.lg) {
        //     bp = 'lg';
        // } else if (this.$vuetify.breakpoint.xl) {
        //     bp = 'xl';
        // }
        // console.log('Breakpoint = ', bp);
    },
    computed: {
        ...mapGetters(['version', 'navMainLogo']),
        mainLogoHeight() {
            var height = '200';
            if (this.$vuetify.breakpoint.xs) {
                height = '250';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '300';
            } else if (this.$vuetify.breakpoint.md) {
                height = '350';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '400';
            } else if (this.$vuetify.breakpoint.xl) {
                height = '450';
            }
            return height;
        },
        bannerClass() {
            var nameClass = '';
            if (this.$vuetify.breakpoint.xs) {
                nameClass = 'cata_xs';
            } else if (this.$vuetify.breakpoint.sm) {
                nameClass = 'cata_sm';
            } else if (this.$vuetify.breakpoint.md) {
                nameClass = 'cata_md';
            } else {
                nameClass = 'cata_lg';
            }
            return nameClass;
        },
        bannerIconHeight() {
            var height = '';
            if (this.$vuetify.breakpoint.xs) {
                height = '20';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '25';
            } else if (this.$vuetify.breakpoint.md) {
                height = '30';
            } else {
                height = '33';
            }
            return height;
        }
    },
    methods: {
        onPromociones() {
            this.$router.push('/promociones').catch(err => {});
        },
        onSucursales() {
            this.$router.push('/sucursales').catch(err => {});
        },
        onMenu() {
            // window.open('@/assets/menu/menu.pdf');
            window.open('http://www.catabocata.com/docs/menu.pdf');
            // window.open('<%= BASE_URL %>menu1.pdf');
        },
        onCatalogo() {
            window.open('http://www.catabocata.com/docs/catalogo.pdf');
        },
        onCentrosConsumo() {
            this.$router.push('/centrosconsumo').catch(err => {});
        },
        onPrivacidad() {
            this.$router.push('/privacidad').catch(err => {});
        },
        onContacto() {
            this.$router.push('/contacto').catch(err => {});
        },
        onFacebook() {
            window.open('https://es-la.facebook.com/CatabocataMX');
        },
        onInstagram() {
            //window.open('https://www.instagram.com/p/Bw7e61SDGPv/');
            window.open('https://www.instagram.com/catabocata_mx/');
        },
        onWhatsApp() {
            window.open('https://wa.me/525551010200');
        },
        onUberEats() {},
        // onPostMates() {},
        onSinDelantal() {},
        onCornerShop() {},
        onDiDiFood() {},
        onGTSF() {
            window.open('http://www.gtsf.com.mx');
        }
    }
};
</script>

<style scoped>
.home {
    /* background: url('../assets/scott-warman-h4AGlo55tTA-unsplash.png');
    background-size: cover;

    background-size: cover;
    width: 100%;
    height: 100%; */
}

.home-buttons {
    background-color: rgba(255, 0, 0, 0.6);
}

.banner-tranqui {
    /* background-color: rgba(183, 28, 28, 0.7); */
    background-color: rgba(192, 4, 20, 0.7);
}

.cata_xs {
    font-family: bourbon;
    font-size: 1.5em;
    font-weight: lighter;
    /* font-weight: lighter; */
    /* font-size: 18px; */
}

.cata_sm {
    font-family: bourbon;
    font-size: 1.8em;
    font-weight: lighter;
}

.cata_md {
    font-family: bourbon;
    font-size: 2em;
    font-weight: lighter;
}

.cata_lg {
    font-family: bourbon;
    font-size: 2.4em;
    font-weight: lighter;
}

.pointer {
    cursor: pointer;
}
</style>
